import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";
import { Colour } from "../Variables";
import { PositionsFiltered } from "../components/Positions/PositionsFiltered";
import { LeftHandMenu } from "../components/LeftHandMenu";
import { ImageCarousel } from "../components/ImageCarousel";
import { Link, useSearchParams } from "react-router-dom";
import { CardSolid } from "../components/Shared/CardSolid";

export function PositionsList() {
    const app = useContext(AppContext);
    const [queryParameters] = useSearchParams();

    let jcc = queryParameters.get("jcc");
    let selectedJobCat = app?.positions.JobCategories.find(x => x.Code == jcc);

    if (app?.positions.JobCategories.findIndex(x => x.Code == jcc) == -1) {
        jcc = null;
        selectedJobCat = null;
    }

    return (
        <>
            {app.redesign_BannerVer != "-1" && <img src={`/app/StyleBundle/banner?v=${app.redesign_BannerVer}`} className={`d-block w-100 mb-3 ${app.redesign_BannerOnly ? "pt-3" : ""}`} alt="Firm banner image" />}

            {!app.redesign_Carousel && !app.redesign_BannerOnly &&
                <InfoBanner
                    header={selectedJobCat == null ? app.positionsLabel : selectedJobCat.Name}
                    narrow={false}
                    icon={InfoHeaderIcon.Positions}
                    info="All current opportunities"
                    subHeader={`${app.firmName} online application system`}
                    theme={Colour.Alt}>
                </InfoBanner>}

            {app.redesign_Carousel && <ImageCarousel />}

            <LeftHandMenu mobileOnly={false} />

            <PositionsFiltered positions={app.positions} intra={false} />

            {!app.loading && app.baseFeatures.JobBoard_Speculatives &&
                <CardSolid title={"Speculative applications"} headerTheme={Colour.Secondary} headerClasses={"mb-3"}>
                    <p>
                        We are always interested in hearing from talented people. So if you don't find exactly what you're looking for, please click below to submit a speculative application.
                    </p>
                    <Link to="Speculative" className="btn btn-wider">Go</Link>
                </CardSolid>}
        </>
    );
}